import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';

const ContactInfoCards = () => {
  const infoItems = [
    {
      icon: Phone,
      title: "Call Us",
      content: companyInfo.phone,
      subContent: "Mon-Sat from 9am to 6pm",
      action: `tel:${companyInfo.phone}`,
      color: "blue"
    },
    {
      icon: Mail,
      title: "Email Us",
      content: companyInfo.email,
      subContent: "We'll respond within 24 hours",
      action: `mailto:${companyInfo.email}`,
      color: "teal"
    },
    {
      icon: MessageCircle,
      title: "WhatsApp",
      content: "Chat with Us",
      subContent: "Instant responses",
      action: `https://wa.me/${companyInfo.whatsapp.replace(/\+|\s/g, '')}`,
      color: "green"
    },
    {
      icon: MapPin,
      title: "Visit Us",
      content: "Ramanattukara, Calicut",
      subContent: "Kerala, India",
      action: "#map",
      color: "indigo"
    }
  ];

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
      {infoItems.map((item, index) => {
        const Icon = item.icon;
        return (
          <motion.a
            href={item.action}
            key={index}
            className="group relativebg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 bg-white"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ y: -5 }}
          >
            <div className={`w-14 h-14 bg-${item.color}-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-${item.color}-100 transition-colors`}>
              <Icon size={28} className={`text-${item.color}-600`} />
            </div>
            
            <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
            <p className="text-lg font-medium text-gray-800 mb-1">{item.content}</p>
            <p className="text-sm text-gray-500">{item.subContent}</p>
          </motion.a>
        );
      })}
    </div>
  );
};

export default ContactInfoCards;
